<template>
  <div class="rating">
    <input class="rating__input" type="radio" checked disabled :name="`rating-${_uid}`">
    <template v-for="(item, itemIndex) in items">
      <label
        class="rating__item"
        v-if="isToShowResponse === item[itemValue] || isToShowResponse === undefined"
        :for="`rating-${_uid}-${item[itemValue]}`"
        :key="`label-${item[itemValue]}`"
        :title="item[itemText]"
        :aria-label="item[itemText]"
      >
        <Icon v-if="isTypeStar" name="star" size="lg" class="rating__icon"/>
        <span
        v-else type="button"
        class="rating__button"
        :class="{[`rating__gradient_button${item.order}${itemIndex}`]: isGradient, 'rating__button_default': !isGradient}"
        :style="{
          'color': isGradient ? 'white' : item.textColor || textColor || 'white',
          }"
        >
        {{item[itemText]}}
        </span>
      </label>
      <input
        v-if="isToShowResponse === item[itemValue] || isToShowResponse === undefined"
        :key="`value-${item[itemValue]}`"
        class="rating__input"
        type="radio"
        :name="`rating-${_uid}`"
        v-model="internalValue"
        v-on:click="sendValue(item[itemValue])"
        :value="item[itemValue]"
        :id="`rating-${_uid}-${item[itemValue]}`"
      >
      <theme-style :key="itemIndex" v-if="isGradient">
        <!-- .rating:hover .rating__gradient_button{{item.order}}{{itemIndex}}{
          background-color:  {{ item.hoverColor || '#ed4d7f' }} !important;
        }
        .rating__item:hover ~ .rating__item > .rating__gradient_button{{item.order}}{{itemIndex}} {
          background-color:  {{ item.bgColor || '#673ab7' }} !important;
        } -->
       .rating__gradient_button{{item.order}}{{itemIndex}} {
          background-color:  {{ item.bgColor || '#673ab7' }} !important;
       }
     </theme-style>

      <theme-style :key="itemIndex" v-else>
       <!-- .rating:hover .rating__button_default {
          background-color:  {{ hoverColor || '#ed4d7f' }} !important;
       }
       .rating__item:hover ~ .rating__item > .rating__button_default {
          background-color:  {{ bgColor || '#673ab7' }} !important;
       } -->
       .rating__button_default {
          background-color:  {{ bgColor || '#673ab7' }} !important;
       }
     </theme-style>

    </template>
    <!-- <span style="top: 60px;" :style="{'color': labelColor}" class="rating__label rating__label--min" v-if="!!minLabel">{{minLabel}}</span>
    <span style="top: 60px;" :style="{'color': labelColor}" class="rating__label rating__label--max" v-if="!!maxLabel">{{maxLabel}}</span> -->
  </div>
</template>

<script>
import Icon from '../Icon/Icon.vue'
import ThemeStyle from '../Theme/ThemeStyle.vue'

export default {
  name: 'AppFormVerticalButton',
  status: 'prototype',
  release: '1.0.0',
  inheritAttrs: false,
  components: { Icon, ThemeStyle },
  props: {
    isToShowResponse: {
      default: undefined
    },
    isGradient: {
      type: Boolean,
      default: true
    },
    value: {
      required: true
    },
    bgColor: {
      type: String
    },
    hoverColor: {
      type: String
    },
    textColor: {
      type: String,
      default: ''
    },
    labelColor: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemText: {
      type: String,
      default: 'text'
    },
    type: {
      type: String,
      default: 'button'
    },
    minLabel: {
      type: String,
      default: null
    },
    maxLabel: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      lazyValue: this.value
    }
  },
  methods: {
    sendValue (item) {
      this.$emit('rate-value', item)
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    },
    isTypeStar () {
      return this.type === 'star'
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
$text-shadow-default: 0 5px 15px rgb(239, 243, 248);
$text-shadow-hover: 0 5px 15px rgba(152, 113, 221, 0.5);
.rating__gradientButton {
  display: inline-block;
  width: 45px;
  height: 45px;
  margin-right: 6px;
  border: 0;
  border-radius: 50%;
  box-shadow: 0 5px 10px 0 rgba($color-purple-light, 0.26);
  // removido para se tornar dinamico ao tema background-color: $color-pink-light;
  font-family: $font-text;
  font-size: $size-s;
  font-weight: 600;
  text-align: center;
  line-height: 45px;
  color: $color-white;
  cursor: pointer;
  outline: none;
  user-select: none;
}
.rating__item:hover {
  @extend %animated-faster;
  @extend %zoomIn;
  }
.rating {
  @include clear-both();
  position: relative;
  display: grid;
  justify-content: center;
  // padding-bottom: 30px;

  &__item {
    display: inline-block;
    float: left;
    cursor: pointer;
    min-width: 230px;
  }
  &__icon {
    display: block;
    width: 54px;
    height: 52px;
    color: $color-purple-light;
    &:before {
      width: 100%;
      display: block;
      text-indent: -9px;
      line-height: 50px;
      text-shadow: $text-shadow-hover;
    }
  }
  &__button {
        display: inline-block;
        border: 0;
        -webkit-box-shadow: 0 5px 10px 0 rgba(152, 113, 221, 0.26);
        box-shadow: 0 5px 10px 0 rgba(152, 113, 221, 0.11);
        font-family: "Open Sans", Helvetica, Arial, sans-serif;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        outline: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        padding: 14px;
        width: 87%;
        margin: 5px;
        border-radius: 25px;
    // font-weight: lighter;
  }
  &__input {
    display: none;
    &:checked ~ .rating__item {
      .rating__icon {
        color: $color-gray-light;
        &:before {
          text-shadow: $text-shadow-default;
        }
      }
      .rating__button {
        // background-color: $color-purple;
      }
    }
  }
  &:hover &__item {
    .rating__icon {
      color: $color-purple;
      &:before {
        text-shadow: $text-shadow-hover;
      }
    }
    .rating__button {
      // removido para se tornar dinamico ao tema background-color: $color-pink-lighter;
    }
  }
  &__item:hover ~ &__item {
    .rating__icon {
      color: $color-gray-light;
      &:before {
        text-shadow: $text-shadow-default;
      }
    }
    .rating__button {
      // removido para se tornar dinamico ao tema background-color: $color-purple;
    }
  }
  &__label {
    position: absolute;
    bottom: 0;
    font-family: $font-text;
    font-size: $size-s;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    color: $color-purple-darker;
    &--min {
      left: 0;
    }
    &--max {
      right: 6px;
    }
  }
}
</style>
